import { Button } from '../../../button';
import { Col } from '../../../col';
import { Icon } from '../../../icon';
import { Delete2LineIcon, RepeatLine } from '../../../icons';
import { Row } from '../../../row';
import { Text } from '../../../typography';

type P = {
  fileName: string;
  removeUpload: () => void;
  retryUpload: () => void;
};

const ErrorFileUpload = ({ fileName, removeUpload, retryUpload }: P) => (
  <div className="ui-video-status ui-video-status--error">
    <Row align="middle" className="ui-video-status__file-row" gutter={['xs', 0]}>
      <Col>
        <Icon className="anticon-paper-clip" icon="attachment-line" />
      </Col>

      <Col className="ui-video-status__file-name" flex="1">
        <Text ellipsis>{fileName}</Text>
      </Col>

      <Col>
        <Button
          danger
          icon={<RepeatLine type="error" />}
          onClick={() => {
            retryUpload();
          }}
          type="link-primary"
        />
      </Col>
      <Col>
        <Button
          danger
          icon={<Delete2LineIcon type="error" />}
          onClick={() => {
            removeUpload();
          }}
          type="link-primary"
        />
      </Col>
    </Row>
  </div>
);

export default ErrorFileUpload;
